module.exports = __webpack_public_path__ + "img/ic-500.c67cf105.svg";